import { invalid } from "moment";

export default {
    addCompany: 'Agregar organización',
    company: 'Organización',
    companyName: 'Nombre de la organización',
    trademark: 'Marca comercial',
    companies: 'Organizaciones',
    companyPlaceHolder: 'Selecciona una organización',
    noCompany: 'Organización no encontrada',
    noCompanies: 'Organizaciones no encontradas',
    legalName: 'Marca y Nombre legal',
    plan: 'Plan',
    subdomain: 'Nombre corto para tu subdominio',
    subdomainNotAvailable: 'Subdominio no disponible',
    subdomainAvailable: 'Subdominio disponible',
    invalidSubdomain: 'El subdominio solo puede contener letras, números y guiones',
    subdomainTooltip: 'El subdominio es el nombre único que identifica a tu organización en la plataforma. Este no puede ser modificado una vez creado. por ejemplo: "miempresa".',
    planPlaceHolder: 'Selecciona un plan',
    noPlan: 'Plan no encontrado',
    noPlans: 'Planes no encontrados',
    brand: 'Marca comercial',
    businessActivity: 'Actividad económica',
    activityPlaceHolder: 'Selecciona una actividad económica',
    noActivity: 'Actividad económica no encontrada',
    noActivities: 'Actividades económicas no encontradas',
    companiesError: 'Ha ocurrido un error al obtener las empresas: ',
    confirmDeleteCompany: '¿Está seguro que desea eliminar la organización?',
    deleteCompanyError: 'Ha ocurrido un error al eliminar la Organización',
    companyDeletedSuccess: 'Organización eliminada exitosamente',
    typeCompanyPlaceHolder: 'Selecciona un tipo de empresa',
    addOrCreateUser: 'Para continuar debes agregar al menos un usuario existente o crear uno nuevo.',
    unknown: 'Desconocido',
    companyQueryError: 'Ha ocurrido un error al consultar la Organización: ',
    companyCreatedSuccess: 'Empresa creada correctamente',
    companyCreationError: 'Ha ocurrido un error al crear la compañia: ',
    companyUpdatedSuccess: 'Empresa actualizada correctamente',
    companyUpdateError: 'Ha ocurrido un error al actualizar la empresa: ',
    companyDeleteUserSuccess: 'Usuario eliminado correctamente',
    companyDeleteUserError: 'Ha ocurrido un error al eliminar el usuario',
    companyAddUserSuccess: 'Usuario agregado correctamente',
    companyAddUserError: 'Ha ocurrido un error al agregar el usuario',
    companyCategory: 'Categoria de empresa',
    companyType: 'Tipo de empresa',
    createCompany: 'Elige o crea una organización para comenzar',
    companyCreate: 'Crear una organización',
    companySelect: 'Elige una organización',
    subdomainError: 'Este subdominio no está permitido, por favor elige otro nombre.',
};
